// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__12OvW","buttons":"SendReceipts_buttons__3DYB2","email":"SendReceipts_email__3B1DK","bookApptTitle":"SendReceipts_bookApptTitle__1jXu6"};